var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{staticClass:"shuffle-btn",class:("" + (_vm.value || 'none')),attrs:{"icon":_vm.icon},on:{"click":_vm.open}})}
var staticRenderFns = []

export { render, staticRenderFns }